import React from "react";
import PropTypes from "prop-types";
import { TableBody, TableCell, TableHead, TableRow, Grid, FormHelperText } from "@mui/material";
import { Button } from "@totalsoft/rocket-ui";
import { useTranslation } from "react-i18next";
import DealerContactModeRowComponent from "./DealerContactModeRowComponent";
import { isValid } from "@totalsoft/pure-validations-react";
import CardNoResultsWrapper from "components/layout/CardNoResultsWrapper";
import { MinWidthTable } from "components/common/TableStyles";

export const DealerContactModeListComponent = ({
  dealer,
  contactModes,
  dealerContactModesList,
  onPropertyChange,
  partnerId,
  addContactMode,
  saveContactModes,
  saveContactModeDisabled,
  validDefaultEmail,
  validDefaultMobilePhone,
  validDefaultPhone,
  validation
}) => {
  const { t } = useTranslation();

  return (
    <Grid container style={{ overflowX: "auto" }}>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <CardNoResultsWrapper content={dealerContactModesList}>
          <MinWidthTable>
            <TableHead>
              <TableRow>
                <TableCell style={{ paddingRight: "150px" }} colSpan={4}>
                  {t("Partner.Type")}
                </TableCell>
                <TableCell style={{ paddingRight: "200px" }} colSpan={4}>
                  {t("Partner.Value")}
                </TableCell>
                <TableCell style={{ textAlign: "center" }} colSpan={2}>
                  {t("ContactInfo.Default")}
                </TableCell>
                <TableCell style={{ textAlign: "center" }} colSpan={2}>
                  {t("ContactInfo.Active")}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dealerContactModesList?.map((document, idx) => {
                return (
                  <DealerContactModeRowComponent
                    key={idx}
                    idx={idx}
                    contactModes={contactModes}
                    contactMode={document}
                    dealerContactMode={document}
                    onPropertyChange={onPropertyChange(idx)}
                    validation={validation[idx]}
                  />
                );
              })}
            </TableBody>
          </MinWidthTable>
        </CardNoResultsWrapper>
        {!validDefaultEmail && (
          <FormHelperText error={true} id="name-error-text">
            {t("ContactInfo.ValidateUniqueDefaultEmail")}
          </FormHelperText>
        )}
        {!validDefaultMobilePhone && (
          <FormHelperText error={true} id="name-error-text">
            {t("ContactInfo.ValidateUniqueDefaultMobilePhone")}
          </FormHelperText>
        )}
        {!validDefaultPhone && (
          <FormHelperText error={true} id="name-error-text">
            {t("ContactInfo.ValidateUniqueDefaultPhone")}
          </FormHelperText>
        )}
        <Button
          id="contactMode_addBtn"
          color="primary"
          variant="contained"
          onClick={() => addContactMode(partnerId, dealer.dealerId)}
          sx={{ marginTop: "1.5rem" }}
        >
          {t("Add")}
        </Button>
        <Button
          id="contactMode_saveBtn"
          color="primary"
          variant="contained"
          onClick={() => saveContactModes(partnerId, dealerContactModesList)}
          disabled={saveContactModeDisabled || !isValid(validation)}
          sx={{ marginLeft: ".25rem", marginTop: "1.5rem" }}
        >
          {t("Save")}
        </Button>
      </Grid>
    </Grid>
  );
};

DealerContactModeListComponent.propTypes = {
  dealer: PropTypes.object.isRequired,
  contactModes: PropTypes.array.isRequired,
  dealerContactModes: PropTypes.array,
  dealerContactModesList: PropTypes.array,
  partnerId: PropTypes.number,
  onPropertyChange: PropTypes.func,
  addContactMode: PropTypes.func.isRequired,
  saveContactModes: PropTypes.func.isRequired,
  saveContactModeDisabled: PropTypes.bool,
  validDefaultEmail: PropTypes.bool,
  validDefaultMobilePhone: PropTypes.bool,
  validDefaultPhone: PropTypes.bool,
  validation: PropTypes.object.isRequired
};

export default DealerContactModeListComponent;
